import c1 from "../../assets/rajeev.jpg";
import c2 from "../../assets/rajkishor.jpg";
import c3 from "../../assets/rupesh.jpg";
import c4 from "../../assets/suraj.jpg";

const data = [
  {
    id: 1,
    image: c1,
    clientName: "Rajeev Yadav",
    review:
      "This portfolio is a visually appealing showcase of his projects and skills. The design is clean, and the navigation is intuitive. The projects are well-presented, highlighting his expertise in various technologies. The use of images and descriptions effectively conveys the purpose and impact of each project. Overall, a great representation of his work.",
  },
  {
    id: 2,
    image: c2,
    clientName: "Rajkisor Yadav",
    review:
  "This portfolio is a masterpiece of design and functionality. The layout is intuitive, allowing for easy navigation and exploration of his projects. The use of graphics and animations adds a dynamic element to the site, making it engaging and memorable. It's clear that he is a skilled developer with a keen eye for detail.",
  },
  {
    id: 3,
    image: c3,
    clientName: "Rupesh Lamichhane",
    review:
      "This portfolio is a testament to his creativity and technical prowess. The layout is sleek and modern, drawing the eye to his impressive projects. The use of colors and typography is well-thought-out, creating a professional and engaging user experience. It's clear that he is a talented developer with a passion for innovation.",
  },
  {
    id: 4,
    image: c4,
    clientName: "Suraj Kabirath",
    review:
"This Portfolio is a stunning display of his skills and achievements. The design is modern and elegant, showcasing his projects in a visually appealing manner. The navigation is smooth, making it easy to explore his work. Overall, a fantastic portfolio that reflects his talent and dedication to his craft.",  },
];
export default data;
